var hd = document.getElementsByTagName('head')[0];
var jq = document.createElement('script');
jq.setAttribute('type', 'text/javascript');
jq.setAttribute('src', 'https://code.jquery.com/jquery-3.6.3.min.js');
hd.appendChild(jq);

jq.onload = function() {
    jQuery(document).ready(function(){
        jQuery('button[class="slider-button slider-button--next"]').on('click',function(){
	        console.log("Slide: " + jQuery(".slider-counter--current").text());
            var curr_slide = eval(jQuery(".slider-counter--current").text());
            jQuery('div[id^="ci_imgtop_"]').each(function(){
                if(!jQuery(this).hasClass("hidden")) {
                    jQuery(this).addClass("hidden");
                }
            });
            jQuery('div[id^="ci_imgbottom_"]').each(function(){
                if(!jQuery(this).hasClass("hidden")) {
                    jQuery(this).addClass("hidden");
                }
            });
            curr_slide = curr_slide + 2;
            jQuery('div[id="ci_imgtop_'+curr_slide+'"]').removeClass("hidden");
            jQuery('div[id="ci_imgbottom_'+curr_slide+'"]').removeClass("hidden");
        });
        jQuery('button[class="slider-button slider-button--prev"]').on('click',function(){
	        console.log("Slide: " + jQuery(".slider-counter--current").text());
            var curr_slide = eval(jQuery(".slider-counter--current").text());
            jQuery('div[id^="ci_imgtop_"]').each(function(){
                if(!jQuery(this).hasClass("hidden")) {
                    jQuery(this).addClass("hidden");
                }
            });
            jQuery('div[id^="ci_imgbottom_"]').each(function(){
                if(!jQuery(this).hasClass("hidden")) {
                    jQuery(this).addClass("hidden");
                }
            });
            if(curr_slide == 2) {
                curr_slide = curr_slide - 1;
            }
            jQuery('div[id="ci_imgtop_'+curr_slide+'"]').removeClass("hidden");
            jQuery('div[id="ci_imgbottom_'+curr_slide+'"]').removeClass("hidden"); 
        });
    });    
}
